export const RARITIES = ['common', 'uncommon', 'rare', 'epic', 'legendary', 'mythic', 'divine', 'senita'] as const;

export type Rarity = (typeof RARITIES)[number];


export const SECRET_RARITY = 'senita' as const satisfies Rarity;

export type PublicRarity = Exclude<Rarity, typeof SECRET_RARITY>;


export const PUBLIC_RARITIES = RARITIES.filter((rarity) => rarity !== SECRET_RARITY) as PublicRarity[];

export function isSecretRarity(rarity: unknown): rarity is typeof SECRET_RARITY {
  return rarity === SECRET_RARITY;
}


export function visibleRarities(senitaUnlocked: boolean): Rarity[] {
  return senitaUnlocked ? [...RARITIES] : PUBLIC_RARITIES;
}

export function isRarity(value: unknown): value is Rarity {
  return typeof value === 'string' && (RARITIES as readonly string[]).includes(value);
}

export function rarityRank(rarity: Rarity): number {
  return RARITIES.indexOf(rarity);
}

export function isAtLeast(rarity: Rarity, minimum: Rarity): boolean {
  return rarityRank(rarity) >= rarityRank(minimum);
}

export function highestRarity(rarities: readonly Rarity[]): Rarity | null {
  let best: Rarity | null = null;
  for (const rarity of rarities) {
    if (best === null || rarityRank(rarity) > rarityRank(best)) best = rarity;
  }
  return best;
}
